import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { DatabaseBody } from '../types/database.types';

/** The Database module: what the root area shows about the database. */
export class DatabaseApi extends AApi {
    /** GET — the tables and the infos of the server. */
    public getDatabase(): Promise<ApiResult<DatabaseBody>> {
        return this.Client.get(`${this.VersionPath}/database`);
    }
}
